import axios from './axios'
import { Visite  } from '@/../../EshJSLib/models/patient'

export async function fetchVisite(id : number) {
    const response = await axios.get(`/api/visitePatient/${id}`);
    return response.data;
}

export async function deletePatient(id: number) {
   const response = await axios.delete(`/api/visite/${id}`);
    return response.data;
}

export async function updateVisite(params:Visite) {
    const response = await axios.put(`/api/visite/${params.id_visita}`,params);

    return response.data;
}



